<template>
  <!-- <router-link to="/login/123">About</router-link> -->
  <router-view  v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
</template>

<style>
#app {
  font-family: 'PingFangSC-Regular', "Microsoft YaHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  padding: 0;
  margin: 0;
}
</style>
